import { createModuleContext } from "@artis/sdk";
import { useMemo } from "react";
/** Prefix that keeps app-level keys out of registered Artis module namespaces. */
export const APP_STORAGE_PREFIX = "app:";
/**
 * Module storage for app features that are not an Artis pane. Unlike
 * {@link useModuleStorage}, this does not need `<ArtisModuleHost>`: it builds a
 * context named `app:${name}` so those rows never collide with a registered module.
 */
export function useAppStorage(name, scope = "user") {
    if (!name || name.includes(":")) {
        throw new Error(`useAppStorage name must be a non-empty identifier without ':'; got "${name}"`);
    }
    return useMemo(() => createModuleContext(`${APP_STORAGE_PREFIX}${name}`).storage(scope), [name, scope]);
}
//# sourceMappingURL=useAppStorage.js.map